import React from "react";
import Shifts from "screens/Shifts/index";
const UnAssignedShifts = () => {
  return <Shifts status="unassigned" />;
};

export default UnAssignedShifts;
